import React, { useEffect, useMemo, useState } from 'react';

/**
 * Hook to determine if a ref is in view
 */
export default function useRefInView(
  ref: React.RefObject<HTMLElement>,
  opts?: IntersectionObserverInit
) {
  const [isInView, setIsInView] = useState(false);

  // Memoize options so caller does not have to
  const options = useMemo(
    () => ({
      root: opts?.root,
      rootMargin: opts?.rootMargin,
      threshold: opts?.threshold
    }),
    [opts?.root, opts?.rootMargin, opts?.threshold]
  );

  useEffect(() => {
    const el = ref.current;

    const observer = new IntersectionObserver(
      ([entry]: IntersectionObserverEntry[]): void => {
        setIsInView(entry.isIntersecting);
      },
      options
    );

    if (el) observer.observe(el);

    return () => {
      if (el) observer.unobserve(el);
    };
  }, [options, ref]);

  return isInView;
}
